var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useCreateClientEmployee } from "../actions";
import { useEditEmployee } from "./use-edit-employee";
export var useCreateEmployeeForm = function (clientId) {
    var _a = useEditEmployee(), name = _a.name, password = _a.password, validate = _a.validate;
    var _b = useCreateClientEmployee(), createEmployee = _b.mutate, isLoading = _b.isLoading, isSuccess = _b.isSuccess;
    var onNameChange = function (evt) {
        return name.set(evt.target.value);
    };
    var onPasswordChange = function (evt) {
        return password.set(evt.target.value);
    };
    var submit = function (evt) {
        evt.preventDefault();
        if (validate()) {
            createEmployee({ name: name.value, password: password.value, clientId: clientId });
        }
    };
    return {
        name: __assign(__assign({}, name), { onChange: onNameChange }),
        password: __assign(__assign({}, password), { onChange: onPasswordChange }),
        submit: submit,
        isLoading: isLoading,
        isSuccess: isSuccess,
    };
};
